import React, { useContext } from 'react';
import { IModifierGroupsContext, ModifierGroupsContext } from '../../../../modifierGroupsState/modifierGroupsContext';
import Text from 'components/Text/Text';
import Item from './components/Item';
import classNames from 'classnames';
import style from './List.module.scss';

const List: React.FC = () => {
	const { setIDForDeletion, modifiersGroups } = useContext<IModifierGroupsContext>(ModifierGroupsContext);

	const nameHeadingClasses = classNames(style.name, style.heading);
	const articleNumberHeadingClasses = classNames(style.articleNumber, style.heading);
	const restaurantHeadingClasses = classNames(style.restaurant, style.heading);
	const customerHeadingClasses = classNames(style.customer, style.heading);
	const actionHeadingClasses = classNames(style.action, style.heading);

	return (
		<div className={style.container} data-test="List">
			<div className={style.tableHeaders}>
				<Text
					className={nameHeadingClasses}
					translationNameSpace="listing"
					translationKey="nameOfModifierGroupLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={articleNumberHeadingClasses}
					translationNameSpace="listing"
					translationKey="articleNumberLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={restaurantHeadingClasses}
					translationNameSpace="listing"
					translationKey="restaurantLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={customerHeadingClasses}
					translationNameSpace="listing"
					translationKey="customerLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={actionHeadingClasses}
					translationNameSpace="listing"
					translationKey="actionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			{modifiersGroups.modifierGroups.map((item, index) => (
				<Item data={item} key={item.id + 'list'} index={index} setIDForDeletion={setIDForDeletion} />
			))}
		</div>
	);
};

export default List;
